import { useTranslation } from '../i18n';
import './EmptyStateHint.scss';

/**
 * Empty state guidance component displayed when calendar has no events or milestones
 * @param {Object} props
 * @param {boolean} props.hasProjects - Whether user has created any projects
 * @param {Function} props.onDismiss - Callback when user dismisses the hint
 */
function EmptyStateHint({ hasProjects, onDismiss }) {
  const { t } = useTranslation();

  return (
    <div className="empty-state-hint">
      <div className="empty-state-hint__content">
        <button 
          className="empty-state-hint__close" 
          onClick={onDismiss}
          title={t('common.close')}
          aria-label={t('common.close')}
        >
          ✕
        </button>
        <h2 className="empty-state-hint__title">{t('emptyState.title')}</h2>
        <div className="empty-state-hint__tips">
          <div className="empty-state-hint__tip">
            <span className="empty-state-hint__icon">✨</span>
            <div className="empty-state-hint__tip-content">
              <strong>{t('emptyState.createEventTitle')}</strong>
              <p>{t('emptyState.createEventDesc')}</p>
            </div>
          </div>

          <div className="empty-state-hint__tip">
            <span className="empty-state-hint__icon">🎯</span>
            <div className="empty-state-hint__tip-content">
              <strong>{t('emptyState.addMilestoneTitle')}</strong>
              <p>{t('emptyState.addMilestoneDesc')}</p>
            </div>
          </div>

          {!hasProjects && (
            <div className="empty-state-hint__tip">
              <span className="empty-state-hint__icon">📁</span>
              <div className="empty-state-hint__tip-content">
                <strong>{t('emptyState.createProjectTitle')}</strong>
                <p>{t('emptyState.createProjectDesc')}</p>
              </div>
            </div>
          )}

          <div className="empty-state-hint__tip">
            <span className="empty-state-hint__icon">❓</span>
            <div className="empty-state-hint__tip-content">
              <strong>{t('emptyState.helpTitle')}</strong>
              <p>{t('emptyState.helpDesc')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmptyStateHint;
